import React from 'react'
import Report from './Report';
import Product from './Product';
import Header from './Header';
import { information , product } from './modal';
import './Style/Invoice.css'
import Footer from './Footer';

function Invoice() {

  let total = product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0)
  let discount = (product.info.reduce((sum, item) => sum + parseInt(item.price) * item.qty, 0) * product.discount/100)  
  let lastPrice = total - discount

  
  var today = new Date();
  var date = today.getFullYear()+' - '+(today.getMonth()+1)+' - '+today.getDate();


  return <div className='invoice'>


        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#3C82FF" fill-opacity="1" d="M0,96L1440,32L1440,0L0,0Z"></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#3C82FF" fill-opacity="0.6" d="M0,192L120,165.3C240,139,480,85,720,64C960,43,1200,53,1320,58.7L1440,64L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#3C82FF" fill-opacity="0.7" d="M0,160L80,133.3C160,107,320,53,480,53.3C640,53,800,107,960,117.3C1120,128,1280,96,1360,80L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
        </svg>

        <Header />
        <Product data={product.info} DateDay={date}/> 

        <Report 
          subTotal={total}
          discount={discount}
          lastPrice={lastPrice}
          product={product}
        />

        <Footer />

  </div>
}

export default Invoice